// Ready-made notices for CustomerNoticeModal. The greeting ("¡Hola, <nombre>!")
// is added by the API, so bodies start after it. Formatting: "## " heading,
// "- " list, "**bold**", "! " yellow warning box, "> " blue notice box.
export const NOTICE_TEMPLATES = [
  {
    id: 'rifa-freak-babi',
    label: 'Rifa Freak Babi Goblin Version',
    subject: 'LOTERIA FREAK BABI GOBLIN VERSION',
    body: `Gracias a tu apoyo durante el Taipei Toy Festival, tienes una (1) participación en la rifa por el derecho de compra de la figura **FREAK BABI GOBLIN VERSION**.

La pieza viene en su bolsa original, con header, y está firmada por **ABAO**. Puedes ver las fotos reales más abajo.

## Cómo participar

Responde a este correo o envíanos un mensaje por Instagram a **@bluppimart** con:

- Tu nombre completo
- Tu usuario de Instagram
- Tu número de la suerte 🍀 (puede ser cualquier número)

Tu boleto 🎟️ se registrará con la primera letra de tu nombre más el número que elijas. Ejemplo: H + 27 = **H27**. Si la combinación ya fue registrada, te contactaremos para que elijas otro número.

**Fecha límite de registro:** viernes 30 de octubre a las 23:59 h (hora del centro de México).

! ⚠️ **Participa solo si estás seguro de realizar la compra en caso de resultar ganador.**

## La rifa

Se realizará el sábado 31 de octubre después de las 11:00 h (hora del centro de México), en una transmisión en vivo desde La Mole en nuestra cuenta de Instagram **@bluppimart**, en colaboración con **@brenthejet**.

## Si ganas

Te enviaremos un mensaje minutos después de la transmisión. A partir de ese momento tendrás **4 horas** para realizar el pago de **$8,000 MXN** mediante link de pago, transferencia o depósito bancario. Te enviaremos los datos de pago solo a ti.

Si el pago no se recibe dentro de ese plazo, la participación se cancelará y se elegirá a un segundo ganador.

## Entrega

El ganador recibirá una cortesía (entrada a La Mole) para recoger su pieza el domingo 1 de noviembre en La Mole (World Trade Center Ciudad de México). Si no puedes asistir o vives fuera de la CDMX, te enviaremos la figura a domicilio sin costo.

## Condiciones

La participación y la cortesía son personales e intransferibles.

> 🔒 **Aviso importante:** solo te contactaremos desde @bluppimart o desde este correo. Nunca te pediremos un pago antes de la rifa.`,
  },
];
